import { useRef } from 'react'
import ReactImageGallery from 'react-image-gallery'

import { Div } from 'components'

import env from '../../../../env/next-env'
import { parsePhotoGcsProtocol, resizePhoto } from '../../../../utils/image-proxy/path'

import { ImageGalleryContainer } from './image-gallery.styled'

interface ImageGalleryProps extends React.HTMLAttributes<HTMLDivElement> {
  items: string[]
  isFullscreen?: boolean
  onScreenChange?: () => void
  onImageClick?: (
    event: React.MouseEvent<HTMLDivElement>,
    imageGallery: React.RefObject<ReactImageGallery>,
  ) => void
  showFullscreenButton?: boolean
  renderFullscreenButton?:
    | ((onClick: React.MouseEventHandler<HTMLElement>, isFullscreen: boolean) => React.ReactNode)
    | undefined
}

export const ImageGallery: React.FC<ImageGalleryProps> = (props: ImageGalleryProps) => {
  const {
    items,
    isFullscreen,
    onScreenChange,
    showFullscreenButton,
    renderFullscreenButton,
    onImageClick,
    ...divAttributes
  } = props
  const imageGalleryRef = useRef<ReactImageGallery>(null)

  const preparedItems = items.map((item) => ({
    original: resizePhoto(
      env.IMAGE_PROXY_HOST,
      parsePhotoGcsProtocol(item),
      env.IMAGE_PROXY_RESIZE_WIDTH,
      env.IMAGE_PROXY_RESIZE_HEIGHT,
    ),
    thumbnail: resizePhoto(
      env.IMAGE_PROXY_HOST,
      parsePhotoGcsProtocol(item),
      env.IMAGE_PROXY_RESIZE_WIDTH / 10,
      env.IMAGE_PROXY_RESIZE_HEIGHT / 10,
    ),
  }))

  const handleOnClick = (event) => {
    if (onImageClick) {
      onImageClick(event, imageGalleryRef)
    }
  }

  const lazyLoad = true

  return (
    <ImageGalleryContainer isFullscreen={isFullscreen} {...divAttributes}>
      <Div>
        <ReactImageGallery
          lazyLoad={lazyLoad}
          onClick={handleOnClick}
          onScreenChange={onScreenChange}
          showPlayButton={false}
          showIndex
          showFullscreenButton={showFullscreenButton}
          useBrowserFullscreen={false}
          items={preparedItems}
          ref={imageGalleryRef}
          renderFullscreenButton={renderFullscreenButton}
        />
      </Div>
    </ImageGalleryContainer>
  )
}

ImageGallery.defaultProps = {
  isFullscreen: false,
  onScreenChange: () => {
    // do nothing
  },
  onImageClick: () => {
    // do nothing
  },
  showFullscreenButton: true,
  renderFullscreenButton: undefined,
}
